<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Service Registration</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Service Registration</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>
<!--
<div class="login-area pt-100">
  <div class="container">
      <h2>Service Registration</h2>

      <div class="login-wrap">
          <div class="row">
              <div class="col-sm-6 col-lg-6">
                  <div class="jobseeker-item">
                      <div class="jobseeker-icon">
                          <i class="flaticon-job-search"></i>
                      </div>

                      <div class="jobseeker-inner">
                          <span>As a</span>
                          <h3>Free Service</h3>
                      </div>

                      <a routerLink="/create_service">Get Started<i class="icofont-arrow-right"></i></a>
                  </div>
              </div>

              <div class="col-sm-6 col-lg-6">
                  <div class="jobseeker-item">
                      <div class="jobseeker-icon">
                          <i class="flaticon-recruitment"></i>
                      </div>

                      <div class="jobseeker-inner">
                          <span>As a</span>
                          <h3>Managed Service/Profile</h3>
                      </div>

                      <a routerLink="/create_profiled_service">Get Started<i class="icofont-arrow-right"></i></a>
                  </div>
              </div>
          </div>
      </div>

  </div>
</div> -->

<div class="pricing-area pt-100">
  <div class="container">
      <div class="row">
          <div class="col-sm-6">
              <div class="pricing-item wow fadeInUp" data-wow-delay=".3s">
                  <!-- <span>Free Basic</span> -->
                  <h3>Basic</h3>
                  <p>Free</p>

                  <ul>
                      <li>Service Registraion</li>
                      <li>Global Views</li>
                      <li>Free Contacts</li>
                      <li>-----</li>
                  </ul>

                  <a class="pricing-btn" routerLink="/create_service">Get Started</a>
              </div>
          </div>

          <div class="col-sm-6">
              <div class="pricing-item pricing-two wow fadeInUp" data-wow-delay=".4s">
                <!-- <span>Free Basic</span> -->
                  <h3>Advanced</h3>
                  <p>Free</p>

                  <ul>
                    <li>Service & Profile Registration</li>
                    <li>Global Views + View Tracking</li>
                    <li>Free Contacts + Advertorials</li>
                    <li>Service/Profile Updates</li>
                  </ul>

                  <a class="pricing-btn" routerLink="/create_profiled_service">Get Started</a>
              </div>
          </div>

          <!-- <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
              <div class="pricing-item wow fadeInUp" data-wow-delay=".5s">
                  <span>Advance</span>
                  <h2>$100</h2>
                  <p>Always</p>

                  <ul>
                      <li>7 Jobs Posting</li>
                      <li>3 Renew Jobs</li>
                      <li>8 Featured Jobs</li>
                      <li>15 Days Duration</li>
                  </ul>

                  <a class="pricing-btn" routerLink="/">Get Started</a>
              </div>
          </div> -->
      </div>
  </div>
</div>

